module.exports = __webpack_public_path__ + "static/media/tooltip-info-icon.24322413.svg";